// extracted by mini-css-extract-plugin
export default {"buyCrypto":"wert_buyCrypto__yHVTu","wertPopup":"wert_wertPopup__1haMB"};